import React from "react";

const CardTables = ({ children }) => {
    return(
        <div className="p-2 border border-slate-400 rounded-lg shadow shadow-slate-500">
            {children}
        </div>
    )
};

export default CardTables;